import { Image as ImageIcon } from 'lucide-react';
import DynamicIcon from '../../../../components/ui/DynamicIcon';

/** True when the icon value is an uploaded/linked image rather than a library icon name. */
export function isImageIcon(icon?: string): boolean {
  if (!icon) return false;
  return (
    icon.startsWith('data:image/') ||
    icon.startsWith('http://') ||
    icon.startsWith('https://') ||
    icon.startsWith('/')
  );
}

/**
 * Renders a menu icon — library glyph, uploaded image, or muted placeholder.
 * Size comes from `className` (Tailwind width/height utilities), colour from
 * the `color` style inherited by the SVG's currentColor.
 */
export default function IconGlyph({
  icon,
  className = 'w-5 h-5',
  color,
}: {
  icon?: string;
  className?: string;
  color?: string;
}) {
  if (!icon) {
    return <ImageIcon className={className} style={{ color: color ?? '#7C8A82', opacity: 0.55 }} />;
  }
  return (
    <span className="inline-flex shrink-0" style={color ? { color } : undefined}>
      <DynamicIcon iconName={icon} className={className} />
    </span>
  );
}
